import styled from "styled-components";

export const CardContainer = styled.div<{ isVisitant: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background-color: #212325;
  border-radius: 1rem;

  > img {
    border-radius: 1rem;
    width: 6rem;
    height: auto;
    object-fit: cover;
    margin-left: 0.4rem;
    ${({ isVisitant }) => isVisitant && "filter: grayscale(100%);"}
  }
  > section {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;
export const LevelContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
`;
